import { render, staticRenderFns } from "./WallpaperCard.vue?vue&type=template&id=a8aa0412&scoped=true"
import script from "./WallpaperCard.vue?vue&type=script&lang=js"
export * from "./WallpaperCard.vue?vue&type=script&lang=js"
import style0 from "./WallpaperCard.vue?vue&type=style&index=0&id=a8aa0412&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8aa0412",
  null
  
)

export default component.exports